import { timeFormat } from "utils/helper-functions";

const getInitialComments = () => {
    return [];
};

const formatAttachmentName = (value, maxLength = 48) => {
    if (!value || value.length <= maxLength) {
        return value;
    }

    const dotIndex = value.lastIndexOf(".");
    if (dotIndex <= 0 || dotIndex === value.length - 1) {
        return `${ value.slice(0, maxLength - 3) }...`;
    }

    const extension = value.slice(dotIndex);
    const fileName = value.slice(0, dotIndex);
    const fileNameMax = maxLength - extension.length - 3;

    if (fileNameMax <= 0) {
        return `${ value.slice(0, maxLength - 3) }...`;
    }

    return `${ fileName.slice(0, fileNameMax) }...${ extension }`;
};

const formatDate = (value) => {
    return timeFormat(value, "DD.MM.YYYY | HH:mm");
};

const CommentsListHelper = {
    getInitialComments,
    formatAttachmentName,
    formatDate,
};

export default CommentsListHelper;
